import {CurrentRoute} from '@/library/route/current-route';

export class MapRouteInRoute {

    private currentRoute = new CurrentRoute();
    private paramId: string = 'marsruts';

    constructor() {
    }

    public value(): string {
        return (this.currentRoute.param(this.paramId) || '');
    }

    public update(values: string): void {
        this.currentRoute.setParam(this.paramId, values);
    }

    public remove(): void {
        this.currentRoute.removeParam(this.paramId);
    }
}
